import * as actionTypes from "../../constants/actionTypes";
import * as componentTypes from "../../constants/componentTypes";
import * as getActions from "../../actions/getActions";
import * as handlers from "../../constants/handlers";
import * as messageHelper from "../../helpers/messageHelper";
import * as modelHelper from "../../helpers/modelHelper";
import * as navigationActions from "../../actions/navigationActions";
import * as responseHelper from "../../helpers/responseHelper";
import * as resultCodes from "../../constants/resultCodes";
import * as ticketingActions from "../../actions/ticketingActions";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.GET_TMC_CONNECTION_STATUS:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.TMC_AVAILABLE,
                    payload: {
                        available: response.data.installed !== null
                    }
                }
            ];
        case handlers.CREATE_TICKET:
            if (!responseHelper.isCreateTicketResponseValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                messageHelper.getSuccessMessageAction("ticketing.successfulCreation"),
                ticketingActions.getTickets(tabId),
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.TICKETING_MODAL
                    }
                }
            ];
        case handlers.GET_TICKETS:
            if (!responseHelper.isTicketingResponseValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let tickets = [];

            response.data.data.forEach((ticket) => {
                let t = modelHelper.mapTicketToObject(ticket);

                if (t !== null) {
                    tickets.push(t);
                }
            });

            return [
                {
                    type: actionTypes.SAVE_TICKETS,
                    payload: {
                        tickets: tickets,
                        count: response.data.count
                    }
                }
            ];
        case handlers.MARK_TICKET_AS_READ:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            if (response.data) {
                return [ticketingActions.getTickets()];
            }

            return [];
        case handlers.TICKETING_GET_FANDECK_LIST:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.TICKETING_SAVE_FANDECK_LIST,
                    payload: {
                        fandeckList: modelHelper.mapFandecksToObjects(response.data)
                    }
                }
            ];
        case handlers.TICKETING_GET_COLOR_LIST:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.TICKETING_SAVE_COLOR_LIST,
                    payload: {
                        colorList: modelHelper.mapColorsToObjects(response.data, false)
                    }
                }
            ];
        case handlers.TICKETING_GET_PRODUCT_LIST:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.TICKETING_SAVE_PRODUCT_LIST,
                    payload: {
                        productList: modelHelper.mapProductsWithoutGroupsToObjects(response.data)
                    }
                }
            ];
        case handlers.TICKETING_GET_BASE_LIST:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.TICKETING_SAVE_BASE_LIST,
                    payload: {
                        baseList: modelHelper.mapBasesToObjects(response.data)
                    }
                }
            ];
        case handlers.GET_SERVICE_DEPARTMENTS:
            if (!responseHelper.isServiceDepartmentsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.TICKETING_SAVE_SERVICE_DEPARTMENTS,
                    payload: {
                        serviceDepartmentList: modelHelper.mapServiceDepartments(response.data)
                    }
                }
            ];
        case handlers.DELETE_TICKET:
            return [ticketingActions.getTickets()];
        case handlers.GET_CUSTOM_FORMULA:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            if (response.data === undefined || response.data === null) {
                return [messageHelper.getInfoMessageAction("flashMessage.formulaDataUnavailable")];
            }

            let mappedColor = modelHelper.mapColorToObject(response.data.colorInFandeck.color);
            let mappedFandeck = modelHelper.mapFandeckToObject(response.data.colorInFandeck.fandeck);
            return [
                getActions.getProductsByParams(
                    tabId,
                    mappedFandeck.id,
                    mappedColor.id,
                    response.data.baseName,
                    response.data.productName,
                    true,
                    false,
                    false,
                    true,
                    handlers.LOAD_TICKET_FORMULA,
                    {mappedColor: mappedColor, mappedFandeck: mappedFandeck, productName: response.data.productName}
                )
            ];
        case handlers.LOAD_TICKET_FORMULA:
            if (!responseHelper.isGroupListFormatValid(response, false)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let available = state.server.requests.find((request) => request.id === response.sequence);

            if (available === undefined) {
                return [];
            }

            if (response.data.length === 0) {
                return [
                    messageHelper.getInfoMessageAction("mainTab.productNotAvailable", {
                        productName: available.next.productName
                    }),
                    navigationActions.selectFormula(
                        available.next.mappedColor,
                        null,
                        available.next.mappedFandeck,
                        null
                    ),
                    navigationActions.closeModal(componentTypes.TICKETING_MODAL)
                ];
            }

            return [
                navigationActions.selectFormula(
                    available.next.mappedColor,
                    modelHelper.mapProductToObject(response.data[0]),
                    available.next.mappedFandeck,
                    null
                ),
                navigationActions.closeModal(componentTypes.TICKETING_MODAL)
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
